import { addResourceBundle } from '@egw/i18n'
import en from './src/i18n/locales/en.json'

addResourceBundle('en', 'features-external-accounts', en)

export * from './src/constants'
export * from './src/pages'
